/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * UserInfo.
 */
export interface UserInfoViewModel { 
    /**
     * UserNo.
     */
    userNo?: string;
    /**
     * UserName.
     */
    userName?: string;
    /**
     * JobTitleName.
     */
    jobTitleName?: string;
    /**
     * MainDuty.
     */
    mainDuty?: boolean;
    /**
     * Priority.
     */
    priority?: number;
    /**
     * FirstPriority.
     */
    firstPriority?: boolean;
    /**
     * ManagerUserId.
     */
    managerUserNo?: string;
    /**
     * DepartmentId.
     */
    departmentId?: number;
    /**
     * DepartmentCode.
     */
    departmentCode?: string;
    /**
     * DepartmentName.
     */
    departmentName?: string;
    /**
     * CompanyId.
     */
    companyId?: number;
    /**
     * CompanyCode.
     */
    companyCode?: string;
    /**
     * CompanyShortName.
     */
    companyShortName?: string;
    /**
     * CompanyName.
     */
    companyName?: string;
    /**
     * Email
     */
    email?: string;
    /**
     * Enable
     */
    enable?: boolean;
    /**
     * IsSalesSupport
     */
    isSalesSupport?: boolean;
}